export default [
  { id: 1, value: 1, label: '〜 15万円',         from: null,    to: 150000 },
  { id: 2, value: 2, label: '15万円 〜 30万円',   from: 150000,  to: 300000 },
  { id: 3, value: 3, label: '30万円 〜 50万円',   from: 300000,  to: 500000 },
  { id: 4, value: 4, label: '50万円 〜 100万円',  from: 500000,  to: 1000000 },
  { id: 5, value: 5, label: '100万円 〜 300万円', from: 1000000, to: 3000000 },
  { id: 6, value: 6, label: '300万円 〜 500万円', from: 3000000, to: 5000000 },
  { id: 7, value: 7, label: '500万円 〜',        from: 5000000, to: null }
]
